import { CLIENT_ROLE } from "@classdojo/web/pods/realtime";
import { Role } from "@classdojo/web/pods/realtime/RealtimeClient";
import URLSearchParams from "url-search-params";

let role: Role | undefined;
let mountPoint: string;
let classId: string;
let roleSlice: string | undefined;
// try parsing with new scheme first
// path looks like "/apps/remote/mobile/52336bbeb74a7a0000000011" or "/apps/display"
// server side won't have window.location
const isRoleType = (val: string): val is Role => {
  const roleValues: string[] = Object.values(CLIENT_ROLE);
  return roleValues.includes(val);
};
if (typeof window !== "undefined") {
  const path = window.location.pathname;
  [roleSlice, mountPoint, classId] = path.split("/").slice(2);
  role = roleSlice && isRoleType(roleSlice) ? roleSlice : undefined;
  // try old scheme
  if (!role && path.startsWith("/apps")) {
    const params = new URLSearchParams(typeof window !== "undefined" ? window?.location?.search : null);
    role = params.get("role") === "display" ? CLIENT_ROLE.DISPLAY : CLIENT_ROLE.REMOTE;
    mountPoint = params.get("modal") === "true" ? "teach" : "mobile";
    classId = params.get("classId");
  }
}

const isDisplay = role === CLIENT_ROLE.DISPLAY;
const isRemote = role === CLIENT_ROLE.REMOTE;
export { role, isDisplay, isRemote, mountPoint, classId };
